import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";

export interface IFieldDependency {
    key: string;
    value: string;
}

export class FieldDependency implements IFieldDependency {

    constructor(data?: IFieldDependency) {
        if (data) this.update(data);
    }

    update(data: IFieldDependency): FieldDependency {
        mapData(data, { root: () => this });
        return this;
    }

    key: string = "";
    value: string = "";

    get hasValue() {
        return !Utils.isEmptyOrWhitespace(this.key)
            && !Utils.isEmptyOrWhitespace(this.value);
    }
}